import ReactDOM from 'react-dom';
import App from './App';
import { Footer } from './components/footer';
import "./main.css"

ReactDOM.render(
  <div>
    <App/>
    <Footer/>
  </div>,
  document.getElementById('root')
);